import React from 'react'
import MaterialIcon from '@material/react-material-icon';
import styles from './Audio.module.scss';
// import './layout.scss';

const pretty = (s) => { return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s }

const Audio = ({ audio }) => {
    const [duration, setDuration] = React.useState(undefined);
    const [currentTime, setCurrentTime] = React.useState(pretty(0));
    const [progress, setProgress] = React.useState(0);
    const [playing, setPlaying] = React.useState(false)

    const play = () => {
        setPlaying(true)

        document.getElementById("player").play()
    }

    const pause = () => {
        setPlaying(false)
        document.getElementById("player").pause()
    }


    return (
        <div className={`${styles.audio} audio`} >
            <audio id="player" src={audio} onTimeUpdate={(e) => { setCurrentTime(pretty(Math.round(e.target.currentTime))); setProgress(e.target.currentTime / e.target.duration) }} onCanPlay={(e) => setDuration(pretty(Math.round(e.target.duration)))} onEnded={() => setPlaying(false)} />
            {playing ?
                <MaterialIcon className={styles.playpause} aria-label="Share" hasRipple icon='pause' onClick={() => pause()} />
                :
                <MaterialIcon className={styles.playpause} aria-label="Share" hasRipple icon='play_arrow' onClick={() => play()} />
            }
            <div className={styles.progressbar} >
                <div style={{ width: `${progress * 100}%` }} className={styles.progress} />
            </div>
            {duration &&
                <div className={styles.duration}>{currentTime} / {duration}</div>
            }
        </div>
    );
}

export default Audio;